"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectEventNamesResult = exports.getProjectEventsUniquesByAggregation = exports.getProjectDashboardEvents = void 0;
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const lodash_1 = __importDefault(require("lodash"));
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const agent_1 = require("@dfinity/agent");
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
//todo remove
const getProjectDashboardEvents = async (actors, accessToken, lastNDays, aggregation) => {
    try {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("EventApiService.getProjectDashboardEvents!!!! ", { lastNDays, aggregation });
        }
        const projectEventNamesResult = await (0, exports.getProjectEventNamesResult)(actors, accessToken);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("EventApiService.getProjectDashboardEvents projectEventNamesResult", projectEventNamesResult);
        }
        if ((0, ICCanisterUtils_1.isICRequestOk)(projectEventNamesResult)) {
            const eventNames = projectEventNamesResult.ok;
            const queryEventVariants = lodash_1.default.compact(lodash_1.default.map(eventNames, eventName => {
                return CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.eventNameToQueryEventVariant(eventName);
            }));
            return (0, exports.getProjectEventsUniquesByAggregation)(actors, accessToken, queryEventVariants, lastNDays, aggregation);
        }
    }
    catch (e) {
    }
    return { err: { "temporarilyUnavailable": null } };
};
exports.getProjectDashboardEvents = getProjectDashboardEvents;
const getProjectEventsUniquesByAggregation = async (actors, accessToken, queryEventVariants, lastNDays, aggregation) => {
    try {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("EventApiService.getProjectEventsUniquesByAggregation", { queryEventVariants, lastNDays, aggregation });
        }
        const result = [];
        if (queryEventVariants.length > 0) {
            const promises = [];
            const taskContexts = [];
            lodash_1.default.each(actors, (actor, actorIdx) => {
                lodash_1.default.each(queryEventVariants, (queryEventVariant, queryEventVariantIdx) => {
                    taskContexts.push({
                        actorIdx: actorIdx,
                        queryEventVariantIdx: queryEventVariantIdx,
                    });
                    promises.push(getProjectEventUniquesByAggregation(actor, accessToken, queryEventVariant, CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(lastNDays), aggregation));
                });
            });
            const promisesResult = await Promise.allSettled(promises);
            if (!!process.env.IS_TEST_SERVER) {
                console.log("EventApiService.getProjectEventsUniquesByAggregation taskContexts", taskContexts);
                console.log("EventApiService.getProjectEventsUniquesByAggregation promisesResult", promisesResult);
                console.log(`EventApiService.getProjectEventsUniquesByAggregation ========================================`);
            }
            const resultRegistry = {};
            lodash_1.default.each(promisesResult, (value, idx) => {
                var _a;
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] ------------------------------`);
                }
                const taskContext = taskContexts[idx];
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] taskContext`, taskContext);
                }
                const featureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(value);
                const featureUniques = (_a = featureState.state) === null || _a === void 0 ? void 0 : _a.uniques;
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] featureUniques`, featureUniques);
                }
                const registryKey = `${taskContext.queryEventVariantIdx}`;
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] registryKey`, registryKey);
                }
                const registryValue = resultRegistry[registryKey];
                if (registryValue == undefined) {
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] add new registry value...`);
                    }
                    //add new registry value
                    resultRegistry[registryKey] = {
                        actorIndexes: [taskContext.actorIdx],
                        queryEventVariantIdx: taskContext.queryEventVariantIdx,
                        uniques: featureUniques
                    };
                }
                else if (!lodash_1.default.includes(registryValue.actorIndexes, taskContext.actorIdx)) {
                    registryValue.actorIndexes.push(taskContext.actorIdx);
                    if (registryValue.uniques == undefined) {
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] registry value has no uniques - just set it...`);
                        }
                        //registry value has no uniques - just set it
                        registryValue.uniques = featureUniques;
                    }
                    else if (featureUniques != undefined) {
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] registry value has uniques - sum it...`, { existing: lodash_1.default.cloneDeep(registryValue.uniques.data), add: lodash_1.default.cloneDeep(featureUniques.data), result: lodash_1.default.cloneDeep(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray([Array.from(registryValue.uniques.data), Array.from(featureUniques.data)])) });
                        }
                        //registry value has uniques - sum it
                        registryValue.uniques.data = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray([Array.from(registryValue.uniques.data), Array.from(featureUniques.data)]));
                    }
                }
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`EventApiService.getProjectEventsUniquesByAggregation promisesResult[${idx}] updated resultRegistry`, lodash_1.default.cloneDeep(resultRegistry));
                }
            });
            lodash_1.default.each(resultRegistry, v => {
                const queryEventVariant = queryEventVariants[v.queryEventVariantIdx];
                result.push({
                    queryEventVariant: CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.queryEventVariantToQueryEventVariantComposite(queryEventVariant),
                    value: v.uniques
                });
            });
        }
        const finalResult = {
            ok: {
                uniques: result
            }
        };
        if (!!process.env.IS_TEST_SERVER) {
            console.log("EventApiService.getProjectEventsUniquesByAggregation result", finalResult);
        }
        return finalResult;
    }
    catch (e) {
    }
    return { err: { "temporarilyUnavailable": null } };
};
exports.getProjectEventsUniquesByAggregation = getProjectEventsUniquesByAggregation;
const getProjectEventUniquesByAggregation = async (actor, accessToken, queryEventVariant, periodType, aggregation) => {
    try {
        let result;
        const queryPartitionRange = ICCanisterUtils_1.MaxPartitionsRange;
        switch (aggregation) {
            case AggregationJSONModel_1.Aggregation.dau:
                result = await actor.getProjectEventUniques(accessToken, queryEventVariant, {
                    periodType: periodType,
                    granularity: { daily: null },
                    partitionsRange: queryPartitionRange
                });
                break;
            case AggregationJSONModel_1.Aggregation.wau:
                result = await actor.getProjectEventUniques(accessToken, queryEventVariant, {
                    periodType: periodType,
                    granularity: { weekly: null },
                    partitionsRange: queryPartitionRange
                });
                break;
            case AggregationJSONModel_1.Aggregation.mau:
                result = await actor.getProjectEventUniques(accessToken, queryEventVariant, {
                    periodType: periodType,
                    granularity: { monthly: null },
                    partitionsRange: queryPartitionRange
                });
                break;
        }
        if ((0, ICCanisterUtils_1.isICRequestOk)(result)) {
            return result;
        }
    }
    catch (e) {
        if (!!process.env.IS_TEST_SERVER) {
            console.error("getProjectEventUniquesByAggregation failed: ", e);
        }
    }
    throw new Error("temporarilyUnavailable");
};
/*
export const eventsUniquesPercentFromDAU = (uniques: Array<DashboardEventData> | undefined, dau: ChartLastNIntervalData | undefined): Array<DashboardEventData> | undefined => {
    const eventsPercentFromDAU: Array<DashboardEventData> | undefined = _.compact(_.map<DashboardEventData, DashboardEventData>(uniques, (dashboardEventData) => {
        let chartLastNIntervalData: ChartLastNIntervalData | undefined = undefined
        if (dashboardEventData.value?.data && dau?.data) {
            const data = _.map<number, number>(dashboardEventData.value.data, (value, idx) => {
                if (dau.data[idx] !== 0) {
                    return value * 100 / dau.data[idx]
                } else {
                    return 0
                }
            });
            chartLastNIntervalData = {
                intervalStartTimeSec: dashboardEventData.value.intervalStartTimeSec,
                data: data
            }
        }
        return {
            eventName: dashboardEventData.eventName,
            value: chartLastNIntervalData
        }
    }))
    return eventsPercentFromDAU
}
*/
/*
const getProjectEventUniquesWeekMonth = async (actor: _SERVICE, accessToken: AccessToken, eventQuery: EventQuery, lastNDays: number): Promise<GetProjectEventUniquesResult> => {
    return new Promise<GetProjectEventUniquesResult>((resolve) => {
        const ranges: Array<Range> = splitPartitionsCountIntoChunks(getNumberOfChunksByLastNDays(lastNDays), USERS_PARTITIONS_COUNT);
        console.log("ranges", ranges);
        const tasks: Array<AsyncFunction<GetProjectEventUniquesResult>> = _.map(ranges, range => (callback) => {
            (async () => {
                try {
                    const result: GetProjectEventUniquesResult = await actor.getProjectEventUniquesDay(accessToken, eventQuery, {last: lastNDays})
                    callback(null, result)
                } catch (e) {
                    callback(e)
                }
            })()
        })
        async.parallelLimit(tasks, 10, (err, results) => {
            if (!_.isNil(err)) {
                console.warn("getProjectEventUniquesDay promises failure: at least one of the chunks failed", err);
                resolve({err: {"temporarilyUnavailable": null}})
            } else {
                if (process.env.NODE_ENV === "development") {
                    console.log(`getProjectEventUniquesDay[${eventQuery.eventDescription.name}] promises results`, results);
                }
                try {
                    const promisesResult = results
                    const thereAreErrors = _.some(promisesResult, (promiseResult) => isICRequestErr(promiseResult))
                    if (thereAreErrors) {
                        console.warn("getProjectEventUniquesDay promises failure: there are backend errors", promisesResult);
                        resolve({err: {"temporarilyUnavailable": null}})
                        return
                    } else {
                        const resultDataArray: Array<EventUniquesChartResultData> = _.compact(_.map(promisesResult, (promiseResult) => {
                            if (isICRequestOk(promiseResult)) {
                                return promiseResult.ok
                            }
                        }))
                        if (process.env.NODE_ENV === "development") {
                            console.log(`getProjectEventUniquesDay[${eventQuery.eventDescription.name}] resultDataArray`, resultDataArray);
                        }
                        const firstData = _.first(resultDataArray);
                        if (firstData) {
                            resolve({err: {"temporarilyUnavailable": null}})

                            return
                        } else {
                            console.warn("getProjectEventUniquesDay promises failure: no success results", promisesResult);
                            resolve({err: {"temporarilyUnavailable": null}})
                            return
                        }
                    }
                } catch (e) {
                    console.warn("getProjectEventUniquesDay failed", e);
                    resolve({err: {"temporarilyUnavailable": null}})
                    return
                }
            }
        })

    })
}
*/
const getProjectEventNamesResult = async (actors, accessToken) => {
    try {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectEventNamesResult: start with", { actors }, lodash_1.default.map(actors, v => agent_1.Actor.canisterIdOf(v).toText()));
        }
        const promises = lodash_1.default.map(actors, actor => actor.getProjectEventNames(accessToken));
        const result = await Promise.all(promises);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectEventNamesResult: result", result);
        }
        const maybeErrorFromAnyChunk = lodash_1.default.find(result, v => {
            if ((0, ICCanisterUtils_1.isICRequestOk)(v)) {
                return false;
            }
            else if ((0, ICCanisterUtils_1.isICRequestErr)(v)) {
                return true;
            }
            return true;
        });
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectEventNamesResult: maybeErrorFromAnyChunk", maybeErrorFromAnyChunk);
        }
        if (maybeErrorFromAnyChunk != undefined) {
            return maybeErrorFromAnyChunk;
        }
        const uniqueEventNames = lodash_1.default.uniq(lodash_1.default.compact(lodash_1.default.flatten(lodash_1.default.map(result, v => {
            if ((0, ICCanisterUtils_1.isICRequestOk)(v)) {
                return v.ok;
            }
        }))));
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectEventNamesResult: uniqueEventNames", uniqueEventNames);
        }
        return {
            ok: uniqueEventNames
        };
    }
    catch (e) {
    }
    return { err: { temporarilyUnavailable: null } };
};
exports.getProjectEventNamesResult = getProjectEventNamesResult;
/*
const getNumberOfChunksByLastNDays = (lastNDays: number): number => {
    if (lastNDays >= 180) {
        return 32
    }
    if (lastNDays >= 90) {
        return 16
    }
    if (lastNDays >= 60) {
        return 8
    }
    if (lastNDays >= 30) {
        return 4
    }
    if (lastNDays >= 15) {
        return 2
    }
    return 1
}
*/
